import type { PricingContext } from "@/types";

// The panel's default settings. It carried three mock shipments -- a
// Rs 22,50,000 sea freight bill among them -- which the deleted allocator
// spread across any line whose origin string matched, including on quotes
// marked domestic. Gone with the blob in BF5d-3; a quote's real shipments are
// QuoteShipment records the backend issues.
export const defaultPricingContext: PricingContext = {
  fx: {
    customsRate: 88.40,
    effectiveFrom: "2026-02-01",
    riskBufferPct: 2.5,
  },
  negotiationBuffer: 0,
};
